import { combineReducers } from "redux";
import members from "./reducers/members";
import admins from "./reducers/admins";
import memberLookups from "./reducers/lookups";
import app from "./reducers/app";
import search from "./reducers/search";
import notifications from "./reducers/notifications";
import reports from "./reducers/reports";
import events from "./reducers/events";
import preachers from "./reducers/preachers";
import noticeCategories from "./reducers/notice_categories";
import notices from "./reducers/notices";
import prayers from "./reducers/prayers";
import meditations from "./reducers/meditations";
import assets from "./reducers/assets";

export default combineReducers({
  notifications,
  search,
  app,
  memberLookups,
  members,
  admins,
  reports,
  events,
  preachers,
  noticeCategories,
  notices,
  prayers,
  meditations,
  assets
});



// WEBPACK FOOTER //
// ./src/rootReducer.js